export const SettingDictionary = {
    "1":"Plain photo",
    "2":"GIF",
    "3":"Boomerang",
    "4":"Augmented reality",
    "5":"Green screen",
    "6":"Mosaic",
    "7":"Slow motion",
    "8":"Monnayeur",
  }